import {
  Swiper,
  Navigation,
  Pagination,
  Keyboard
} from 'swiper';

Swiper.use([Navigation, Keyboard, Pagination]);

const sliderSections = document.querySelectorAll(".s-feedback-slide");

sliderSections.forEach(slideSection => {
  const slider = slideSection.querySelector(".s-feedback-slide__slider");
  const buttonPrev = slideSection.querySelector(".swiper-button-prev");
  const buttonNext = slideSection.querySelector(".swiper-button-next");
  const pagination = slideSection.querySelector(".swiper-pagination");

  const swiperSettings = {
    navigation: {
      nextEl: buttonNext,
      prevEl: buttonPrev,
    },
    pagination: {
      el: pagination,
      type: 'bullets',
      clickable: true,
    },
    keyboard: true,
    draggable: true,
    allowTouchMove: true,
    slidesPerView: 1,
    spaceBetween: 8,
    updateOnWindowResize: true,
  };

  new Swiper(slider, swiperSettings);
});
